import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { LeaveManagementRow } from './leave-management-row';
import { ILeaveManagement } from '../type';
import { useAuthRolePermissions } from '@app/utils';

interface Props {
  tableProps: TableProps;
  rows?: ILeaveManagement[];
  loading: boolean;
}

const LeaveManagementList = ({ tableProps, rows, loading }: Props) => {
  const { hasPermission } = useAuthRolePermissions();
  const canEditLeaveSetting = hasPermission('LeaveSetting', 'w');

  const TABLE_HEAD = [
    { id: 'id', label: 'id', align: 'center' },
    { id: 'leaveType', label: 'Leave Type', align: 'center' },
    { id: 'allowedDays', label: 'Days', align: 'center', sortable: false },
    ...(canEditLeaveSetting
      ? [
          { id: 'status', label: 'Status', align: 'center', sortable: false },
          { id: 'action', label: 'Action', align: 'center', sortable: false },
        ]
      : []),
  ];

  return (
    <PaginatedTable<ILeaveManagement>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={rows}
      isServerSidePaging={false}
      loading={loading}
    >
      {(row) => (
        <LeaveManagementRow
          row={row}
          selected={tableProps.selected.includes(row.id)}
          onSelectRow={() => {
            ('');
          }}
        />
      )}
    </PaginatedTable>
  );
};
export default LeaveManagementList;
